const initialState = {
	expenses: [],
	expense_groupings: [],
	expense_types: [],
	expense_status: [],
	payment_types: [],
	providers: [],
	loading: false,
	error: ''
};

export default (state = initialState, action) => {
	switch (action.type) {
		case 'GET_EXPENSES':
			return {
				...state,
				expenses: action.payload,
				loading: false,
				error: ''
			};
		case 'GET_EXPENSE_GROUPINGS':
			return {
				...state,
				expense_groupings: action.payload,
				loading: false,
				error: ''
			};
		case 'GET_EXPENSE_TYPES':
			return {
				...state,
				expense_types: action.payload,
				loading: false,
				error: ''
			};
		case 'GET_EXPENSE_STATUS':
			return {
				...state,
				expense_status: action.payload,
				loading: false,
				error: ''
			};
		case 'GET_PAYMENT_TYPES':
			return {
				...state,
				payment_types: action.payload,
				loading: false,
				error: ''
			};
		case 'GET_PROVIDERS':
			return {
				...state,
				providers: action.payload,
				loading: false,
				error: ''
			};
		case 'LOADING':
			return { ...state, loading: true };
		case 'ERROR':
			return {
				...state,
				error: action.payload,
				loading: false
			};

		default:
			return state;
	};
};